module.exports = __webpack_public_path__ + "img/linkyt.fa445742.svg";